/* ============================================================
   Limited Edition product page — visual proxy layer.

   The native Size / Frame / White-Border <select> elements remain the source of
   truth (read by framing.js for the live frame preview and by theme.js for
   variant resolution + price/inventory updates). This script:
     - reflects clicks on the visual controls onto those hidden selects
       (set value + dispatch a native 'change' so all existing listeners fire),
     - fills the size table with per-variant dimensions, price and stock,
     - keeps the visual selected/disabled states in sync on every change.
   It never resolves the cart variant or touches the frame preview directly.
   ============================================================ */
(function () {
  function init(root) {
    if (!root || root.__leInit) return;
    var leVariants = root.querySelector('.le-variants');
    var jsonEl = root.querySelector('[data-product-json]');
    if (!leVariants || !jsonEl) return;
    root.__leInit = true;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var product = data.product || {};
    var variants = (product.variants || []).filter(function (v) {
      return Number(v.price) > 0;
    });
    var inventories = data.inventories || {};

    var sizePos = parseInt(leVariants.getAttribute('data-le-size-pos'), 10) || 0;
    var framePos = parseInt(leVariants.getAttribute('data-le-frame-pos'), 10) || 0;
    var moneyFormat = leVariants.getAttribute('data-le-money-format') || '${{amount}}';

    var sizeSelect = root.querySelector('.product-form__option.Size select, select[data-select-name="Size"]');
    var frameSelect = root.querySelector('.product-form__option.Frame select, select[data-select-name="Frame"]');
    var borderSelect = root.querySelector('#native-white-border-select');

    // ---- helpers -------------------------------------------------------------
    function optKey(pos) {
      return 'option' + pos;
    }

    function findVariant(sizeVal, frameVal) {
      return variants.filter(function (v) {
        if (sizePos && v[optKey(sizePos)] !== sizeVal) return false;
        if (framePos && frameVal != null && v[optKey(framePos)] !== frameVal) return false;
        return true;
      })[0];
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      var value = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
    }

    function parseSize(value) {
      var measure = value.match(/(\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*(?:cm|mm|inch|in|")?)/i);
      var name = value.split(/\s+-\s+|\(/)[0].trim() || value;
      return {
        name: name,
        dims: measure ? measure[0].replace(/\s+/g, ' ').trim() : ''
      };
    }

    function stockInfo(variant) {
      if (!variant) return { label: '', cls: 'is-out', sold: true };
      if (!variant.available) return { label: 'Sold out', cls: 'is-out', sold: true };

      var inv = inventories[String(variant.id)] || {};
      var managed = variant.inventory_management || inv.inventory_management;
      var qty = typeof variant.inventory_quantity === 'number'
        ? variant.inventory_quantity
        : inv.inventory_quantity;

      if (managed && typeof qty === 'number') {
        if (qty <= 0) return { label: 'Sold out', cls: 'is-out', sold: true };
        return {
          label: qty + ' left',
          cls: qty <= 5 ? 'is-low' : '',
          sold: false
        };
      }
      return { label: 'In stock', cls: '', sold: false };
    }

    function setSelect(select, value) {
      if (!select || select.value === value) return false;
      // only set if the option exists (the cascading filter may have pruned it)
      var exists = Array.prototype.some.call(select.options, function (o) {
        return o.value === value;
      });
      if (!exists) return false;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    // ---- click wiring ---------------------------------------------------------
    leVariants.querySelectorAll('.le-size-row').forEach(function (row) {
      row.addEventListener('click', function () {
        if (row.hasAttribute('disabled')) return;
        setSelect(sizeSelect, row.getAttribute('data-le-size'));
        sync();
      });
    });

    leVariants.querySelectorAll('.le-frame-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.hasAttribute('disabled')) return;
        setSelect(frameSelect, sw.getAttribute('data-le-frame'));
        sync();
      });
    });

    leVariants.querySelectorAll('.le-mount-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSelect(borderSelect, btn.getAttribute('data-le-border'));
        sync();
      });
    });

    // Re-sync whenever the underlying selects change (covers cascading filter,
    // theme variant scripts and any other source of truth changes).
    [sizeSelect, frameSelect, borderSelect].forEach(function (sel) {
      if (sel) sel.addEventListener('change', sync);
    });

    // ---- render / sync --------------------------------------------------------
    function sync() {
      var curSize = sizeSelect ? sizeSelect.value : null;
      var curFrame = frameSelect ? frameSelect.value : null;
      var curBorder = borderSelect ? borderSelect.value : null;

      // Size rows: dims + price + stock for the currently selected frame.
      leVariants.querySelectorAll('.le-size-row').forEach(function (row) {
        var sizeVal = row.getAttribute('data-le-size');
        var parsed = parseSize(sizeVal);
        var nameEl = row.querySelector('.le-size-row__name');
        var dimsEl = row.querySelector('[data-le-dims]');
        var priceEl = row.querySelector('[data-le-price]');
        var stockEl = row.querySelector('[data-le-stock]');

        if (nameEl && parsed.name && parsed.name !== sizeVal) nameEl.textContent = parsed.name;
        if (dimsEl) dimsEl.textContent = parsed.dims;

        var variant = findVariant(sizeVal, framePos ? curFrame : null);
        if (variant && priceEl) priceEl.textContent = formatMoney(variant.price);

        var info = stockInfo(variant);
        if (stockEl) {
          stockEl.textContent = info.label;
          stockEl.className = 'le-size-row__stock ' + info.cls;
        }

        var unavailable = !variant || info.sold;
        if (unavailable) {
          row.setAttribute('disabled', '');
        } else {
          row.removeAttribute('disabled');
        }
        row.setAttribute('aria-checked', sizeVal === curSize ? 'true' : 'false');
      });

      // Frame swatches: selected + availability for the current size.
      var frameSelectedLabel = leVariants.querySelector('[data-le-frame-selected]');
      if (frameSelectedLabel) frameSelectedLabel.textContent = curFrame || '';
      leVariants.querySelectorAll('.le-frame-swatch').forEach(function (sw) {
        var frameVal = sw.getAttribute('data-le-frame');
        var variant = findVariant(curSize, frameVal);
        if (variant) {
          sw.removeAttribute('disabled');
        } else {
          sw.setAttribute('disabled', '');
        }
        sw.setAttribute('aria-checked', frameVal === curFrame ? 'true' : 'false');
      });

      // Mount toggle: selected state.
      leVariants.querySelectorAll('.le-mount-btn').forEach(function (btn) {
        btn.setAttribute('aria-checked', btn.getAttribute('data-le-border') === curBorder ? 'true' : 'false');
      });
    }

    sync();

    // Safety net: if no #native-white-border-select exists, framing.js waits for
    // 'infinityOptionsLoaded' before binding. Fire it once so the preview boots.
    if (!borderSelect) {
      window.addEventListener('load', function () {
        window.dispatchEvent(new Event('infinityOptionsLoaded'));
      });
    }
  }

  function boot() {
    document.querySelectorAll('.card--limited-edition').forEach(function (card) {
      var section = card.closest('[data-section-type="product"]') || document;
      init(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
